<template>
  <v-container class="pa-2">
    <StoreForManager />
  </v-container>
</template>

<script>
import StoreForManager from "./StoreForManager";
import { mapState } from "vuex";
export default {
  name: "StoreMain",
  components: {
    StoreForManager,
  },
  computed: {
    ...mapState(["user"]),
  },
  data: () => ({
    role: "Sales",
  }),
};
</script>
